import { createContext } from 'react'
import { ActivationObjectProviderValue } from '../types'

export const ActivationObjectContext = createContext<ActivationObjectProviderValue>({
    create: () => {},
    finish: () => {},
    update: () => {},
    finishPcoObject: false,
    isUpdating: false,
})
